// extracted by mini-css-extract-plugin
module.exports = {"root":"_14n74","cell":"tZvfw","emptyData":"_1S7cc","outline":"Pa6G2"};